export const ROUTES = {
  HOME_PAGE: '/',
  USER_LOGIN: '(/user/login|/signin|/selfserve/login)',
  RECOVER_FROM_SESSION: '/user/login/callback',
  USER_ACCOUNT: '/user/account',
  WELCOME_TOKEN: '/welcome/:token',
  USER_SIGNUP: '/signin/register',
  USER_PASSWORD_RESET: '/signin/reset-password',
  USER_FORGOT_PASSWORD: '/signin/forgot-password',
};
